import { Component, ViewEncapsulation, input, inject, effect, ChangeDetectionStrategy } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NoticeSignal } from '@xanadu/signal';

@Component({
    selector: 'app-notice',
    template: '',
    styleUrls: ['./notice.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class NoticeComponent {
    private readonly snackBar = inject(MatSnackBar);
    private readonly noticeSignal = inject(NoticeSignal);

    meta = input<any>();

    constructor() {
        effect(() => {
            const notice = this.noticeSignal.notice();

            if (notice?.text) {
                this.snackBar.open(notice.text, undefined, {
                    duration: 3000,
                    panelClass: notice.type
                });
            }
        });
    }
}
